import { Link } from '@tanstack/react-router';
import { Button } from '@tremor/react';
import { Dropdown } from 'flowbite-react';
import { createColumnHelper } from '@tanstack/react-table';
import { MoreVertical } from 'lucide-react';
import { Trans, t } from '@lingui/macro';

import { DataTableColumnHeader } from '../data-table';

import type { Installer } from '@/api/model';

const columnHelper = createColumnHelper<Installer>();
export const installerColumns = ({
  onDelete,
}: {
  onDelete: (installer: Installer) => void;
}) => [
  columnHelper.accessor((installer) => installer.name, {
    id: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t`Name`} />
    ),
    cell: (properties) => (
      <Link
        to='/installers/$installerId/edit'
        params={{
          installerId: properties.row.original.id.toString(),
        }}
        className='flex hover:text-primary'
      >
        <span className='ml-2 self-center font-semibold'>
          {properties.getValue()}
        </span>
      </Link>
    ),
  }),
  columnHelper.accessor((installer) => installer.expertise, {
    id: 'expertise',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t`Expertise`} />
    ),
  }),
  columnHelper.accessor((installer) => installer.location, {
    id: 'location',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t`Location`} />
    ),
  }),
  columnHelper.display({
    id: 'actions',
    cell: ({ row }) => (
      <div className='flex justify-end gap-1 relative'>
        <Dropdown
          label=''
          renderTrigger={() => (
            <Button variant='secondary' className='px-2' icon={MoreVertical} />
          )}
          dismissOnClick={false}
          placement='bottom'
        >
          <Dropdown.Item>
            <Link
              to='/installers/$installerId/edit'
              params={{
                installerId: row.original.id.toString(),
              }}
            >
              <Trans>Edit</Trans>
            </Link>
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              onDelete(row.original);
            }}
          >
            <Trans>Delete</Trans>
          </Dropdown.Item>
        </Dropdown>
      </div>
    ),
  }),
];
